import React from 'react';
import PageLoader from 'common-ui/src/components/loader/PageLoader';

const LoadingComponent = () => {
    return <PageLoader />;
};

export default LoadingComponent;
